var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZ10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101.547 75.862",
    width: 101.547,
    height: 75.862,
    enableBackground: "new 0 0 101.547 75.862",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.117,6.776C33,6.575,50.883,6.373,68.766,6.172C73.84,6.115,78.914,6.057,83.988,6 c-0.505-1.863-1.009-3.727-1.514-5.59C59.185,16.093,35.632,31.984,15.968,52.202C10.429,57.897,5.265,63.934,0.504,70.294 c-1.48,1.977,0.575,4.373,2.59,4.514c24.985,1.756,50.114,1.32,75.02-1.333c7.102-0.757,14.186-1.693,21.244-2.79 c1.602-0.249,2.489-2.257,2.095-3.69c-0.47-1.71-2.083-2.345-3.69-2.095c-24.318,3.781-48.975,5.39-73.578,4.876 c-7.037-0.147-14.069-0.473-21.091-0.967c0.863,1.505,1.727,3.009,2.59,4.514c16.429-21.947,38.313-39.072,60.63-54.648 c6.348-4.431,12.766-8.76,19.187-13.084c2.37-1.596,1.612-5.626-1.514-5.59C66.105,0.202,48.222,0.403,30.339,0.605 c-5.074,0.057-10.148,0.114-15.221,0.172C11.259,0.82,11.249,6.82,15.117,6.776L15.117,6.776z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ10);
export default __webpack_public_path__ + "static/media/z10.28e391dbca4dffdf0531245d812f507d.svg";
export { ForwardRef as ReactComponent };